import React, { useEffect } from 'react';

const DispatchPatronPage = () => {
  useEffect(() => {
    // Ajouter la balise noindex pour cette page
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);

    // Charger html2pdf.js
    const html2pdfScript = document.createElement('script');
    html2pdfScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
    document.head.appendChild(html2pdfScript);

    return () => {
      document.head.removeChild(metaRobots);
      if (document.head.contains(html2pdfScript)) {
        document.head.removeChild(html2pdfScript);
      }
    };
  }, []);

  return (
    <div dangerouslySetInnerHTML={{ __html: `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">

<style>
  /* --- STYLE DE L'APPLICATION (INTERFACE) --- */
  body { font-family: 'Segoe UI', sans-serif; background: #000; padding: 5px; margin: 0; }
  .box { max-width: 500px; margin: auto; background: #062614; border: 2px solid #22c55e; border-radius: 12px; padding: 15px; color: white; }
  h2 { color: #22c55e; text-align: center; border-bottom: 1px solid #22c55e; padding-bottom: 10px; margin-top: 0; font-size: 18px; text-transform: uppercase; }
  label { font-size: 11px; font-weight: bold; color: #22c55e; display: block; margin-top: 8px; text-transform: uppercase; }
  input, select, textarea { width: 100%; padding: 10px; margin-top: 3px; border: 1px solid #166534; background: #14532d; color: white; border-radius: 5px; box-sizing: border-box; font-size: 13px; font-family: 'Segoe UI', sans-serif; }
  textarea { resize: vertical; min-height: 50px; }
  .row { display: flex; gap: 10px; }
  .sugg { position: absolute; background: #14532d; border: 1px solid #22c55e; z-index: 99; width: 100%; display: none; max-height: 150px; overflow-y: auto; }
  .sugg div { padding: 8px; cursor: pointer; border-bottom: 1px solid #064e3b; font-size: 12px; }
  .sugg div:hover { background: #166534; color: #4ade80; }
  .price-box { background: rgba(34, 197, 94, 0.1); border: 1px solid #22c55e; padding: 15px; text-align: center; margin-top: 15px; border-radius: 8px; }
  .val-price { font-size: 32px; font-weight: 900; color: #4ade80; }
  button { width: 100%; padding: 12px; border: none; border-radius: 5px; font-weight: bold; font-size: 14px; margin-top: 10px; cursor: pointer; text-transform: uppercase; }
  button:disabled { background: #14532d; color: #aaa; cursor: not-allowed; }
  
  button.add-stop { background: transparent; color: #22c55e; border: 1px dashed #22c55e; font-size: 11px; padding: 6px; margin-top: 5px; cursor: pointer; border-radius: 4px; width: auto; display: inline-block; }
  button.add-stop:hover { background: rgba(34, 197, 94, 0.1); }


  .btn-pdf { background: #e2b13c; color: #000; font-size: 16px; margin-top: 20px;}
  .btn-mail { background: #ea4335; color: white; } 
  .btn-wa { background: #25d366; color: white; } 
  .btn-valider { background: #3b82f6; color: white; font-size: 16px; margin-top: 15px; border: 1px solid #60a5fa;}
  .btn-valider:hover { background: #2563eb; }


  .radio-group { display: flex; gap: 10px; margin-top: 5px; margin-bottom: 10px; background: #14532d; padding: 10px; border-radius: 5px; border: 1px solid #166534; }
  .radio-group label { display: flex; align-items: center; gap: 5px; margin-top: 0; color: white; cursor: pointer; font-size: 11px; font-weight: normal; text-transform: none; }
  .radio-group input[type="radio"] { width: auto; margin: 0; cursor: pointer; accent-color: #22c55e; }
  
  .extra-line { display: flex; gap: 5px; margin-top: 5px; align-items: center; }
  .extra-line input[type="text"] { flex: 3; }
  .extra-line input[type="number"] { flex: 1; }
  .btn-remove { background: #ea4335; color: white; width: 30px; height: 30px; padding: 0; margin: 0; border-radius: 5px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-weight: bold;}


  /* --- STYLE DU DEVIS PDF --- */
  #devis_print { display: none; background: white; color: #333; padding: 50px; font-family: 'Arial', sans-serif; width: 793px; margin: 0 auto; box-sizing: border-box; }
  .p-header { display: flex; justify-content: space-between; border-bottom: 3px solid #e2b13c; padding-bottom: 20px; margin-bottom: 30px; align-items: flex-start; }
  .p-logo { max-width: 250px; max-height: 100px; object-fit: contain; }
  .p-title { font-size: 38px; font-weight: 900; color: #e2b13c; text-transform: uppercase; letter-spacing: 2px; margin: 0; }
  .p-info { font-size: 11px; line-height: 1.5; color: #555; margin-top: 10px; }
  .p-client-box { display: flex; justify-content: space-between; margin-bottom: 40px; }
  .p-client { border: 1px solid #ddd; border-left: 4px solid #e2b13c; padding: 20px; width: 45%; background: #fafafa; border-radius: 4px; }
  .p-meta { width: 40%; text-align: right; font-size: 13px; }
  .p-table { width: 100%; border-collapse: collapse; margin-bottom: 30px; border: 1px solid #ddd; }
  .p-table th { background: #f4f4f4; color: #333; padding: 12px; text-align: left; font-size: 13px; border-bottom: 2px solid #e2b13c; text-transform: uppercase; }
  .p-table td { border-bottom: 1px solid #eee; padding: 15px 12px; font-size: 13px; vertical-align: top; }
  .p-totals-container { display: flex; justify-content: flex-end; }
  .p-totals { width: 40%; }
  .p-totals table { width: 100%; border-collapse: collapse; }
  .p-totals td { padding: 10px; border-bottom: 1px solid #eee; font-size: 14px; }
  .p-totals .ttc-row { background: rgba(226, 177, 60, 0.1); font-weight: bold; font-size: 18px; color: #000; border-top: 2px solid #e2b13c; border-bottom: none; }
  .p-notes { margin-top: 20px; padding: 15px; background: #f8f9fa; border-left: 4px solid #333; font-size: 12px; font-style: italic; display: none; }
  .p-sign { margin-top: 50px; padding: 20px; border: 1px dashed #ccc; width: 45%; background: #fafafa; }
  .p-footer { margin-top: 50px; font-size: 9px; color: #777; text-align: center; line-height: 1.6; border-top: 1px solid #ddd; padding-top: 15px; }
</style>
</head>
<body>


<div class="box" id="app_form">
  <h2>DISPATCH PATRON & DEVIS</h2>
  
  <div class="row">
    <div style="flex:1"><label>Civilité</label><select id="civ"><option>Mr</option><option>Mme</option><option>Société</option></select></div>
    <div style="flex:3"><label>Nom, Prénom ou Société</label><input id="nom" type="text" placeholder="Obligatoire"></div>
  </div>
  <label>Adresse du Client (Pour le Devis)</label><input id="adr_fiscale" type="text" placeholder="Ex: 10 rue de la Gare, 59000 Lille">
  <div class="row"><div style="flex:1"><label>Tel</label><input id="tel" type="text" placeholder="06..."></div><div style="flex:1"><label>Email</label><input id="email" type="email" placeholder="Obligatoire pour l'envoi"></div></div>


  <div class="row">
    <div style="flex:1"><label>Passagers</label><select id="pax" onchange="calc()"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option><option value="6">6</option><option value="7">7</option><option value="8">8</option></select></div>
    <div style="flex:2"><label>Attribution Chauffeur</label>
      <select id="chauffeur_force" onchange="calc()">
        <option value="">🤖 Auto (Selon Pax et Distance)</option>
        <option value="Patrick (Van)">🚐 Forcer: Patrick (Van)</option>
        <option value="Jules (Van)">🚐 Forcer: Jules (Van)</option>
        <option value="Abdess (Berline)">🚘 Forcer: Abdess (Berline)</option>
        <option value="Olivier (Berline)">🚘 Forcer: Olivier (Max 2 pax)</option>
      </select>
    </div>
  </div>


  <label>Départ (Maps)</label><div style="position:relative"><input id="dep" type="text" oninput="search(this,'s_dep')" placeholder="Ex: Aéroport CDG ou 10 rue Ligny..."><div id="s_dep" class="sugg"></div></div>
  
  <label>Arrêt Supplémentaire 1 (Optionnel)</label>
  <div style="position:relative"><input id="adr_sup_1" type="text" oninput="search(this,'s_sup_1')" placeholder="Ex: Arrêt en cours de route"><div id="s_sup_1" class="sugg"></div></div>
  
  <div id="bloc_sup_2" style="display:none; margin-top:5px;">
    <label>Arrêt Supplémentaire 2</label>
    <div style="position:relative"><input id="adr_sup_2" type="text" oninput="search(this,'s_sup_2')" placeholder="Ex: Deuxième arrêt"><div id="s_sup_2" class="sugg"></div></div>
  </div>


  <div id="bloc_sup_3" style="display:none; margin-top:5px;">
    <label>Arrêt Supplémentaire 3</label>
    <div style="position:relative"><input id="adr_sup_3" type="text" oninput="search(this,'s_sup_3')" placeholder="Ex: Troisième arrêt"><div id="s_sup_3" class="sugg"></div></div>
  </div>
  <button type="button" class="add-stop" onclick="addStop(this)">+ Ajouter un arrêt sur la route</button>


  <label>Arrivée (Maps ou Mot-Clé)</label><div style="position:relative"><input id="arr" type="text" oninput="search(this,'s_arr')" placeholder="Ex: Gare Lille Flandres ou 'mise a disposition 1h'"><div id="s_arr" class="sugg"></div></div>


  <label>Type de Trajet</label>
  <div class="radio-group">
    <label><input type="radio" name="type_trajet" value="Aller Simple" checked onchange="toggleDates()"> Aller Simple</label>
    <label><input type="radio" name="type_trajet" value="Retour Simple" onchange="toggleDates()"> Retour</label>
    <label><input type="radio" name="type_trajet" value="Aller-Retour" onchange="toggleDates()"> Aller-Retour</label>
  </div>


  <div id="bloc_aller" class="row">
    <div style="flex:1"><label id="lbl_date_aller">Date</label><input id="date_aller" type="date" onchange="calc()"></div>
    <div style="flex:1"><label>Heure</label><input id="heure_aller" type="time" onchange="calc()"></div>
  </div>
  
  <div id="bloc_retour" style="display:none; margin-top:10px; background: #064e3b; padding: 10px; border-radius: 5px; border: 1px dashed #22c55e;">
    <h4 style="margin: 0 0 10px 0; color: #4ade80; font-size: 12px; text-transform: uppercase;">Options du Trajet Retour</h4>
    <label>Départ Retour (Vide si identique à l'arrivée aller)</label>
    <div style="position:relative"><input id="dep_retour" type="text" oninput="search(this,'s_dep_ret')" placeholder="Ex: Bureau, Autre adresse..."><div id="s_dep_ret" class="sugg"></div></div>
    <label>Arrivée Retour (Vide si identique au départ aller)</label>
    <div style="position:relative"><input id="arr_retour" type="text" oninput="search(this,'s_arr_ret')" placeholder="Ex: Maison, Autre adresse..."><div id="s_arr_ret" class="sugg"></div></div>
    
    <div class="row" style="margin-top: 10px;">
      <div style="flex:1"><label id="lbl_date_retour">Date Retour</label><input id="date_retour" type="date" onchange="calc()"></div>
      <div style="flex:1"><label>Heure Retour</label><input id="heure_retour" type="time" onchange="calc()"></div>
    </div>
  </div>


  <div style="margin-top: 15px; border: 1px dashed #22c55e; padding: 10px; border-radius: 5px;">
      <label style="color: #4ade80; font-size: 12px;">➕ Ajouter d'autres prestations (Temps d'attente, Siège...)</label>
      <div id="extra_services_list"></div>
      <button type="button" class="add-stop" style="border-style: dotted;" onclick="addExtraService()">+ Ajouter une prestation manuelle</button>
  </div>


  <label>Notes / Informations Complémentaires (Vol, Siège...)</label>
  <textarea id="notes_devis" placeholder="Ex: Numéro de vol AF1234, Siège auto inclus, Attente aéroport comprise..."></textarea>


  <div class="price-box">
    TARIF TOTAL TTC<br><span id="total" class="val-price">0</span> €
    <div style="display:none;"><span id="ht">0.00</span><span id="tva">0.00</span></div>
  </div>


  <button onclick="genererPDF()" class="btn-pdf" id="btn_pdf" disabled>CONNEXION AUX TARIFS EN COURS...</button>
  <div class="row">
    <button onclick="preparerGmail()" class="btn-mail">2. 📧 GMAIL</button>
    <button onclick="envoyerWhatsApp()" class="btn-wa">3. 💬 WHATSAPP</button>
  </div>
  
  <button onclick="validerCommande()" class="btn-valider" id="btn_valider">4. ✅ VALIDER ET ENVOYER LA COMMANDE</button>


</div>


<div id="devis_print">
  <div class="p-header">
    <div>
      <img src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop,q=95/zxZ8ISTIAGD8Nhk7/allo-navettes-logo-uFQOX6AaDY4dFUGH.png" alt="Allo Navettes" class="p-logo" id="logo_img">
      <div class="p-info">
        <strong>SAS VTC des Weppes</strong><br>
        59134 Beaucamps-Ligny<br>
        Tel : 06 95 73 13 20<br>
        Email : contact@allonavettes.fr<br>
        SIRET : 918 489 659 00014 | TVA : FR 77 918 489 659
      </div>
    </div>
    <div style="text-align: right;">
      <h1 class="p-title">DEVIS</h1>
    </div>
  </div>


  <div class="p-client-box">
    <div class="p-client">
      <span style="font-size: 11px; color: #777;">DESTINATAIRE :</span><br><br>
      <span id="p_client_nom" style="font-size: 16px; font-weight: bold; color:#000;"></span><br>
      <span id="p_client_adr" style="color: #333; line-height: 1.5;"></span><br>
      <span id="p_client_tel" style="color: #555;"></span><br>
      <span id="p_client_email" style="color: #555;"></span>
    </div>
    <div class="p-meta">
      <div style="margin-bottom: 8px;"><strong>N° Devis :</strong> <span id="p_num"></span></div>
      <div style="margin-bottom: 8px;"><strong>Date d'émission :</strong> <span id="p_date_emission"></span></div>
      <div><strong>Validité de l'offre :</strong> 30 jours</div>
    </div>
  </div>


  <table class="p-table">
    <thead>
      <tr>
        <th>Description de la prestation de transport</th>
        <th style="text-align: right; width: 25%;">Montant TTC</th>
      </tr>
    </thead>
    <tbody id="p_table_body">
    </tbody>
  </table>


  <div id="p_notes_container" class="p-notes">
    <strong>Informations complémentaires :</strong> <span id="p_notes_text"></span>
  </div>


  <div class="p-totals-container">
    <div class="p-totals">
      <table>
        <tr>
          <td>Total HT</td>
          <td style="text-align: right;"><span id="p_ht"></span> €</td>
        </tr>
        <tr>
          <td>TVA (10%)</td>
          <td style="text-align: right;"><span id="p_tva"></span> €</td>
        </tr>
        <tr class="ttc-row">
          <td>TOTAL TTC</td>
          <td style="text-align: right;"><span id="p_total"></span> €</td>
        </tr>
      </table>
    </div>
  </div>
  <div class="clear"></div>


  <div class="p-sign">
    <strong style="color: #333;">BON POUR ACCORD</strong><br>
    <span style="font-size: 10px; color: #777;">Date et signature du client (précédées de la mention "Lu et approuvé") :</span><br><br><br><br>
  </div>


  <div class="p-footer">
    SAS VTC des Weppes au capital de 1 500 € - RCS Lille Métropole 918 489 659<br>
    Assurance Responsabilité Civile Professionnelle : Thélem Assurance (Contrat n° TMRP13225089)<br>
    En cas de retard de paiement, une pénalité égale à 3 fois le taux d'intérêt légal sera exigible.<br>
    Le transfert est garanti sous réserve de disponibilité des véhicules au moment de la signature du présent devis.
  </div>
</div>


<script>
const SCRIPT_URL_TARIFS = "https://script.google.com/macros/s/AKfycby-Cqdi-5vTC5zyH8NnMo2myE2ttny2bSJbZysS2-2yai775q2X4I_rkF8UW4JSFz5d/exec";


const latBase = 50.6063;
const lonBase = 2.9348;
let latA=0, lonA=0, latB=0, lonB=0;
let latSup1=0, lonSup1=0, latSup2=0, lonSup2=0, latSup3=0, lonSup3=0;
let latDepR=0, lonDepR=0, latArrR=0, lonArrR=0;
let searchTimeout;
let customTarifs = [];
let stopCount = 1;
let extraCount = 0;


window.onload = function() {
  fetch(SCRIPT_URL_TARIFS + "?action=getTarifs")
    .then(r => r.json())
    .then(data => { 
        if (Array.isArray(data)) { customTarifs = data; } else { customTarifs = []; }
        document.getElementById('btn_pdf').disabled = false;
        document.getElementById('btn_pdf').innerText = "1. 📝 TÉLÉCHARGER LE DEVIS (PDF)";
        calc();
    })
    .catch(e => {
        customTarifs = [];
        document.getElementById('btn_pdf').disabled = false;
        document.getElementById('btn_pdf').innerText = "1. 📝 TÉLÉCHARGER LE DEVIS (PDF)";
    });
};


function isHolidayOrSunday(dateStr) {
  if (!dateStr) return false; let d = new Date(dateStr); if (d.getDay() === 0) return true; 
  let month = d.getMonth() + 1, day = d.getDate();
  if ((month===1&&day===1)||(month===5&&day===1)||(month===5&&day===8)||(month===7&&day===14)||(month===8&&day===15)||(month===11&&day===1)||(month===11&&day===11)||(month===12&&day===25)) return true;
  return false;
}


function toggleDates() {
  let type = document.querySelector('input[name="type_trajet"]:checked').value;
  let blocAller = document.getElementById('bloc_aller'), blocRetour = document.getElementById('bloc_retour');
  let lblAller = document.getElementById('lbl_date_aller');
  if (type === "Aller Simple") { blocAller.style.display = "flex"; blocRetour.style.display = "none"; lblAller.innerText = "Date Aller"; } 
  else if (type === "Retour Simple") { blocAller.style.display = "flex"; blocRetour.style.display = "none"; lblAller.innerText = "Date Prise en Charge"; } 
  else if (type === "Aller-Retour") { blocAller.style.display = "flex"; blocRetour.style.display = "block"; lblAller.innerText = "Date Aller"; }
  calc();
}


function addStop(btnElem) {
  if (stopCount === 1) { document.getElementById('bloc_sup_2').style.display = 'block'; stopCount++; }
  else if (stopCount === 2) { document.getElementById('bloc_sup_3').style.display = 'block'; stopCount++; btnElem.style.display = 'none'; }
}


function addExtraService() {
    extraCount++;
    let div = document.createElement("div");
    div.className = "extra-line";
    div.id = "extra_line_" + extraCount;
    div.innerHTML = \`
        <input type="text" id="desc_extra_\${extraCount}" placeholder="Description de la prestation (ex: Attente 1h, Siège bébé...)">
        <input type="number" id="prix_extra_\${extraCount}" placeholder="Prix TTC" value="0" onchange="calc()" onkeyup="calc()">
        <button type="button" class="btn-remove" onclick="removeExtraService(\${extraCount})">X</button>
    \`;
    document.getElementById("extra_services_list").appendChild(div);
}


function removeExtraService(id) {
    document.getElementById("extra_line_" + id).remove();
    calc();
}


function search(inp, boxId){
  let box=document.getElementById(boxId); 
  if(!box || inp.value.length < 3){ 
    if(box) box.style.display="none"; 
    return; 
  }
  if(typeof searchTimeout !== 'undefined') clearTimeout(searchTimeout);
  searchTimeout = setTimeout(() => {
    fetch('https://nominatim.openstreetmap.org/search?format=json&limit=5&countrycodes=fr,be,nl&q=' + encodeURIComponent(inp.value))
    .then(r => r.json()).then(d => { 
      if(!box) return;
      box.innerHTML=""; 
      box.style.display="block"; 
      if(d && d.length > 0) {
        d.forEach(i => { 
          let dv=document.createElement('div'); 
          dv.innerText=i.display_name; 
          dv.onclick=() => { 
            inp.value=i.display_name; 
            if(boxId==='s_dep'){latA=parseFloat(i.lat);lonA=parseFloat(i.lon)}
            else if(boxId==='s_sup_1'){latSup1=parseFloat(i.lat);lonSup1=parseFloat(i.lon)}
            else if(boxId==='s_sup_2'){latSup2=parseFloat(i.lat);lonSup2=parseFloat(i.lon)}
            else if(boxId==='s_sup_3'){latSup3=parseFloat(i.lat);lonSup3=parseFloat(i.lon)}
            else if(boxId==='s_arr'){latB=parseFloat(i.lat);lonB=parseFloat(i.lon)}
            else if(boxId==='s_dep_ret'){latDepR=parseFloat(i.lat);lonDepR=parseFloat(i.lon)}
            else if(boxId==='s_arr_ret'){latArrR=parseFloat(i.lat);lonArrR=parseFloat(i.lon)}
            box.style.display="none"; 
            calc(); 
          }; 
          box.appendChild(dv); 
        });
      } else {
        box.innerHTML = '<div style="padding: 8px; color: #94a3b8;">Aucune adresse trouvée</div>';
      }
    }).catch(e => { 
      console.error("Maps API error:", e);
      if(box) {
        box.innerHTML = '<div style="padding: 8px; color: #ef4444;">Erreur de recherche</div>';
      }
    });
  }, 600);
}


function getDist(la1,lo1,la2,lo2){ const R=6371; const dLat=(la2-la1)*Math.PI/180; const dLon=(lo2-lo1)*Math.PI/180; const a=Math.sin(dLat/2)**2+Math.cos(la1*Math.PI/180)*Math.cos(la2*Math.PI/180)*Math.sin(dLon/2)**2; return (2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a)))*R; }


function calc(){
  let pax = parseInt(document.getElementById('pax').value);
  let txt = (document.getElementById('dep').value+" "+document.getElementById('arr').value).toLowerCase().normalize("NFD").replace(/[\\u0300-\\u036f]/g, "").replace(/-/g, " ");
  let type = document.querySelector('input[name="type_trajet"]:checked').value;
  let isAR = (type === "Aller-Retour");
  let pBase = 0;


  let forcedChauf = document.getElementById('chauffeur_force').value;
  
  if (forcedChauf.includes("Olivier") && pax > 2) {
      alert("⚠️ SÉCURITÉ : Olivier a un petit coffre (Max 2 passagers). La course bascule sur Abdess !");
      document.getElementById('chauffeur_force').value = "Abdess (Berline)";
      forcedChauf = "Abdess (Berline)";
  }
  
  let chauf = forcedChauf !== "" ? forcedChauf : ((pax >= 4) ? "Patrick (Van)" : "Abdess (Berline)");


  const getForfait = (p2, p3, p4) => { 
      if(chauf.includes("Van") && pax < 4) return p4; 
      if(pax <= 2) return p2; 
      if(pax === 3) return p3; 
      if(txt.includes('mise a disposition') && pax >= 4) return p4; 
      if(pax === 4) return p4; 
      return p4 + ((pax-4)*5); 
  };


  let isForfait = false;


  if (Array.isArray(customTarifs)) {
      for (let i = 0; i < customTarifs.length; i++) {
          if (!customTarifs[i] || !customTarifs[i].motCle) continue;
          let motClePropre = customTarifs[i].motCle.toLowerCase().normalize("NFD").replace(/[\\u0300-\\u036f]/g, "").replace(/-/g, " ");
          if (txt.includes(motClePropre)) {
              pBase = getForfait(customTarifs[i].p2, customTarifs[i].p3, customTarifs[i].p4);
              isForfait = true; break;
          }
      }
  }


  if(!isForfait) {
      if(txt.includes('cdg') || txt.includes('roissy') || txt.includes('charles de gaulle')) { pBase=getForfait(290, 300, 310); isForfait = true; }
      else if(txt.includes('orly')) { pBase=getForfait(350, 360, 370); isForfait = true; }
      else if(txt.includes('charleroi')) { pBase=getForfait(190, 200, 210); isForfait = true; }
      else if(txt.includes('zaventem') || txt.includes('bruxelles')) { pBase=getForfait(190, 200, 210); isForfait = true; }
      else if(txt.includes('beauvais')) { pBase=getForfait(285, 295, 305); isForfait = true; }
      else if(txt.includes('eindhoven')) { pBase=getForfait(400, 410, 420); isForfait = true; }
      else if(txt.includes('amsterdam') || txt.includes('schiphol')) { pBase=getForfait(420, 430, 440); isForfait = true; }
      else if(txt.includes('ostende') || txt.includes('ostend')) { pBase=getForfait(150, 165, 175); isForfait = true; }
      
      else if(txt.includes('mise a disposition 1h')) { pBase=getForfait(80, 80, 80); isForfait = true; }
      else if(txt.includes('mise a disposition 2h')) { pBase=getForfait(160, 160, 160); isForfait = true; }
      else if(txt.includes('mise a disposition 3h')) { pBase=getForfait(240, 240, 240); isForfait = true; }
      else if(txt.includes('mise a disposition 4h')) { pBase=getForfait(320, 320, 320); isForfait = true; }
  }
  
  if(isForfait) {
     let distClient = 0;
     if (latA && latB) {
         let distA = getDist(latBase, lonBase, latA, lonA) * 1.3;
         let distB = getDist(latBase, lonBase, latB, lonB) * 1.3;
         distClient = Math.min(distA, distB);
     } else if (latA) {
         distClient = getDist(latBase, lonBase, latA, lonA) * 1.3;
     }
     if (distClient > 10) { pBase += (Math.ceil((distClient - 10) / 10) * 5); }
  }
  else if(latA && latB) {
      let kmTrajet = getDist(latA, lonA, latB, lonB) * 1.75;
      let kmApproche = getDist(latBase, lonBase, latA, lonA) * 1.75;
      let kmRetour = getDist(latB, lonB, latBase, lonBase) * 1.75;
      
      let pCalc = (kmTrajet * 1.40) + (kmApproche * 0.30) + (kmRetour * 0.30);
      if(kmTrajet > 100) pCalc = pCalc * 0.90;
      
      let prixBaseBerline = Math.max(pCalc, 50); 
      pBase = getForfait(prixBaseBerline, prixBaseBerline + 10, prixBaseBerline + 20);
  }


  let pExtra = 0;
  if (latA && lonA && latB && lonB) {
      let pathLat = [latA];
      let pathLon = [lonA];


      if (latSup1 && lonSup1 && document.getElementById('adr_sup_1').value !== "") { pathLat.push(latSup1); pathLon.push(lonSup1); }
      if (latSup2 && lonSup2 && document.getElementById('adr_sup_2').value !== "") { pathLat.push(latSup2); pathLon.push(lonSup2); }
      if (latSup3 && lonSup3 && document.getElementById('adr_sup_3').value !== "") { pathLat.push(latSup3); pathLon.push(lonSup3); }
      
      pathLat.push(latB);
      pathLon.push(lonB);


      if (pathLat.length > 2) { 
          let kmDirect = getDist(latA, lonA, latB, lonB) * 1.75;
          let kmAvecArrets = 0;
          for (let i = 0; i < pathLat.length - 1; i++) {
              kmAvecArrets += getDist(pathLat[i], pathLon[i], pathLat[i+1], pathLon[i+1]) * 1.75;
          }
          let kmDetour = kmAvecArrets - kmDirect;
          if (kmDetour > 0) { 
              pExtra = kmDetour * 1.40;
          }
      }
  }


  let prixFinal = 0;
  if (pBase > 0) {
      let pAller = pBase + pExtra;
      let dateAller = document.getElementById('date_aller').value;
      if (dateAller && isHolidayOrSunday(dateAller)) pAller *= 1.08;
      prixFinal += pAller;


      if (isAR) {
          let pBaseRetour = 0;
          let latDepRetourEffectif = latDepR ? latDepR : latB;
          let lonDepRetourEffectif = lonDepR ? lonDepR : lonB;
          let latArrRetourEffectif = latArrR ? latArrR : latA;
          let lonArrRetourEffectif = lonArrR ? lonArrR : lonA;


          if (!latDepR && !latArrR) {
              pBaseRetour = pBase;
          } else if (latDepRetourEffectif && latArrRetourEffectif) {
              let kmTrajetRetour = getDist(latDepRetourEffectif, lonDepRetourEffectif, latArrRetourEffectif, lonArrRetourEffectif) * 1.75;
              pBaseRetour = Math.max(kmTrajetRetour * 1.40, 50);
          }


          let pRetour = pBaseRetour + pExtra;
          let dateRetour = document.getElementById('date_retour').value;
          if (dateRetour && isHolidayOrSunday(dateRetour)) pRetour *= 1.08;
          prixFinal += pRetour;
      }
  }


  let prixExtraLignes = 0;
  let extraInputs = document.querySelectorAll('[id^="prix_extra_"]');
  extraInputs.forEach(input => { prixExtraLignes += parseFloat(input.value || 0); });


  let total = Math.round(prixFinal + prixExtraLignes);
  document.getElementById('total').innerText=total;
  document.getElementById('ht').innerText=(total/1.1).toFixed(2);
  document.getElementById('tva').innerText=(total-(total/1.1)).toFixed(2);
}
setInterval(calc, 1000);


function genererPDF() {
  if(document.getElementById('total').innerText === "0") { alert("Veuillez d'abord remplir les adresses."); return; }
  if(document.getElementById('nom').value === "") { alert("Le nom du client est obligatoire."); return; }


  let btn = document.getElementById('btn_pdf');
  let textOriginal = btn.innerText;
  btn.innerText = "GÉNÉRATION EN COURS... PATIENTEZ";
  btn.disabled = true;


  let now = new Date();
  let dateJour = ("0" + now.getDate()).slice(-2) + "/" + ("0" + (now.getMonth() + 1)).slice(-2) + "/" + now.getFullYear();
  let numDevis = now.getFullYear().toString() + ("0" + (now.getMonth() + 1)).slice(-2) + "-" + Math.floor(Math.random() * 9000 + 1000);
  const formatFR = (dStr) => { if(!dStr) return ""; let p=dStr.split('-'); return p.length===3 ? p[2]+"/"+p[1]+"/"+p[0] : dStr; };


  document.getElementById('p_num').innerText = numDevis;
  document.getElementById('p_date_emission').innerText = dateJour;
  document.getElementById('p_client_nom').innerText = document.getElementById('civ').value + " " + document.getElementById('nom').value;
  document.getElementById('p_client_adr').innerText = document.getElementById('adr_fiscale').value || "Adresse non renseignée";
  document.getElementById('p_client_tel').innerText = document.getElementById('tel').value ? "Tel : " + document.getElementById('tel').value : "";
  document.getElementById('p_client_email').innerText = document.getElementById('email').value ? "Email : " + document.getElementById('email').value : "";
  
  let tbody = document.getElementById('p_table_body');
  tbody.innerHTML = "";
  
  let typeTrajetStr = document.querySelector('input[name="type_trajet"]:checked').value;
  let detailTrajet = \`<strong style="color: #e2b13c;">Type : \${typeTrajetStr}</strong><br><br><strong>📍 Départ :</strong> \${document.getElementById('dep').value}\`;
  
  let arr_sups = [];
  if(document.getElementById('adr_sup_1') && document.getElementById('adr_sup_1').value) arr_sups.push(document.getElementById('adr_sup_1').value);
  if(document.getElementById('adr_sup_2') && document.getElementById('adr_sup_2').value) arr_sups.push(document.getElementById('adr_sup_2').value);
  if(document.getElementById('adr_sup_3') && document.getElementById('adr_sup_3').value) arr_sups.push(document.getElementById('adr_sup_3').value);


  if(arr_sups.length > 0) { detailTrajet += \`<br><strong style="color: #777;">⏸️ Arrêt(s) intermédiaire(s) :</strong> \${arr_sups.join(" | ")}\`; }
  
  detailTrajet += \`<br><strong>🏁 Arrivée :</strong> \${document.getElementById('arr').value}<br><br>📅 Le \${formatFR(document.getElementById('date_aller').value)} à \${document.getElementById('heure_aller').value}<br>👥 Passagers : \${document.getElementById('pax').value}\`;


  if(typeTrajetStr === "Aller-Retour") {
      let depRet = document.getElementById('dep_retour') ? document.getElementById('dep_retour').value : "";
      if (depRet === "") depRet = document.getElementById('arr').value;
      
      let arrRet = document.getElementById('arr_retour') ? document.getElementById('arr_retour').value : "";
      if (arrRet === "") arrRet = document.getElementById('dep').value;
      
      detailTrajet += \`<br><br><strong style="color: #e2b13c;">TRAJET RETOUR :</strong><br><strong>📍 Départ :</strong> \${depRet}<br><strong>🏁 Arrivée :</strong> \${arrRet}<br>📅 Le \${formatFR(document.getElementById('date_retour').value)} à \${document.getElementById('heure_retour').value}\`;
  }


  let extrasText = [];
  for (let i = 1; i <= extraCount; i++) {
      let descInput = document.getElementById("desc_extra_" + i);
      if (descInput && descInput.value !== "") {
          extrasText.push(descInput.value);
      }
  }
  if (extrasText.length > 0) {
      detailTrajet += \`<br><br><strong style="color: #777;">➕ Prestations incluses au forfait :</strong> \${extrasText.join(" | ")}\`;
  }


  let trPrincipal = document.createElement("tr");
  trPrincipal.innerHTML = \`<td>\${detailTrajet}</td><td style="text-align: right; font-weight: bold; font-size: 16px;">\${document.getElementById('total').innerText} €</td>\`;
  tbody.appendChild(trPrincipal);
  
  document.getElementById('p_ht').innerText = document.getElementById('ht').innerText;
  document.getElementById('p_tva').innerText = document.getElementById('tva').innerText;
  document.getElementById('p_total').innerText = document.getElementById('total').innerText;


  let notesValue = document.getElementById('notes_devis').value.trim();
  if(notesValue !== "") {
      document.getElementById('p_notes_container').style.display = "block";
      document.getElementById('p_notes_text').innerText = notesValue;
  } else {
      document.getElementById('p_notes_container').style.display = "none";
  }


  let appForm = document.getElementById('app_form');
  let devisPrint = document.getElementById('devis_print');
  
  appForm.style.display = 'none';
  devisPrint.style.display = 'block';
  window.scrollTo(0, 0); 


  setTimeout(() => {
      let nomFichier = 'Devis_AlloNavettes_' + document.getElementById('nom').value.replace(/\\s+/g, '_') + '.pdf';


      let opt = {
        margin:       0,
        filename:     nomFichier,
        image:        { type: 'jpeg', quality: 1 },
        html2canvas:  { scale: 2, useCORS: true },
        jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' }
      };


      html2pdf().set(opt).from(devisPrint).save().then(() => {
        devisPrint.style.display = 'none';
        appForm.style.display = 'block';
        btn.innerText = textOriginal;
        btn.disabled = false;
      }).catch(err => {
        alert("Erreur lors de la création du PDF. L'image du logo bloque peut-être le système.");
        console.log(err);
        devisPrint.style.display = 'none';
        appForm.style.display = 'block';
        btn.innerText = textOriginal;
        btn.disabled = false;
      });
  }, 500);
}


function preparerGmail() {
  let email = document.getElementById('email').value;
  if(!email) { alert("Saisissez l'email du client pour préparer l'envoi !"); return; }
  let nom = document.getElementById('nom').value;
  let total = document.getElementById('total').innerText;
  let type = document.querySelector('input[name="type_trajet"]:checked').value;
  let dep = document.getElementById('dep').value;
  let arr = document.getElementById('arr').value;
  let subject = encodeURIComponent("Votre Devis VTC - Allo Navettes");
  let bodyText = "Bonjour " + nom + ",\\n\\nSuite à votre demande, veuillez trouver ci-joint votre devis officiel pour votre trajet VTC ("+ type +").\\n\\n- Départ : " + dep + "\\n- Arrivée : " + arr + "\\n- Tarif garanti : " + total + " € TTC\\n\\nCe tarif est fixe. Pour valider ce devis, il vous suffit de nous le retourner signé avec la mention \\"Bon pour accord\\".\\n\\nRestant à votre disposition,\\nL'équipe Allo Navettes.";
  let body = encodeURIComponent(bodyText);
  let urlGmail = "https://mail.google.com/mail/?view=cm&fs=1&to=" + email + "&su=" + subject + "&body=" + body;
  window.open(urlGmail, '_blank');
}


function envoyerWhatsApp() {
  let tel = document.getElementById('tel').value;
  if(!tel) { alert("Saisissez le tel du client !"); return; }
  if(tel.startsWith('0')) tel = '33' + tel.substring(1);
  tel = tel.replace(/\\s+/g, '');
  let nom = document.getElementById('nom').value;
  let total = document.getElementById('total').innerText;
  let msg = "Bonjour " + nom + ", voici l'estimation de votre trajet Allo Navettes. Le tarif fixe garanti est de " + total + " € TTC. Souhaitez-vous recevoir le devis complet au format PDF par email ?";
  window.open("https://wa.me/" + tel + "?text=" + encodeURIComponent(msg), "_blank");
}


function validerCommande() {
  if(document.getElementById('total').innerText === "0") { alert("⚠️ Veuillez d'abord remplir les adresses."); return; }
  if(document.getElementById('nom').value === "") { alert("⚠️ Le nom du client est obligatoire."); return; }
  if(document.getElementById('date_aller').value === "" || document.getElementById('heure_aller').value === "") { alert("⚠️ La date et l'heure aller sont obligatoires."); return; }


  let btn = document.getElementById('btn_valider');
  let originalText = btn.innerText;
  btn.innerText = "⏳ ENVOI EN COURS... PATIENTEZ";
  btn.disabled = true;


  let formData = new URLSearchParams();
  formData.append("civ", document.getElementById('civ').value);
  formData.append("nom", document.getElementById('nom').value);
  formData.append("email", document.getElementById('email').value);
  formData.append("tel", document.getElementById('tel').value);
  formData.append("adr_fiscale", document.getElementById('adr_fiscale').value);
  formData.append("pax", document.getElementById('pax').value);
  formData.append("chauffeur_force", document.getElementById('chauffeur_force').value);
  formData.append("dep", document.getElementById('dep').value);
  formData.append("arr", document.getElementById('arr').value);
  formData.append("date_aller", document.getElementById('date_aller').value);
  formData.append("heure_aller", document.getElementById('heure_aller').value);
  
  formData.append("notes", document.getElementById('notes_devis').value);
  
  let typeTrajet = document.querySelector('input[name="type_trajet"]:checked').value;
  if (typeTrajet === "Aller-Retour") {
      formData.append("date_retour", document.getElementById('date_retour').value);
      formData.append("heure_retour", document.getElementById('heure_retour').value);
      formData.append("dep_retour", document.getElementById('dep_retour').value || document.getElementById('arr').value);
      formData.append("arr_retour", document.getElementById('arr_retour').value || document.getElementById('dep').value);
  }
  
  formData.append("prix", document.getElementById('total').innerText);
  formData.append("pay_method", "bord");


  fetch(SCRIPT_URL_TARIFS, {
      method: 'POST',
      body: formData
  })
  .then(response => response.text())
  .then(result => {
      alert("✅ COMMANDE VALIDÉE !\\n\\nLe chauffeur a reçu son Bon de Commande (BOERS) et la course a été ajoutée dans votre Google Sheets.");
      btn.innerText = originalText;
      btn.disabled = false;
  })
  .catch(error => {
      alert("❌ Erreur de connexion avec le serveur. Veuillez réessayer.");
      console.error(error);
      btn.innerText = originalText;
      btn.disabled = false;
  });
}
</script>
</body>
</html>
    ` }} />
  );
};

export default DispatchPatronPage;